import { render } from "./PdfViewer.vue?vue&type=template&id=5cb1f12f&ts=true"
import script from "./PdfViewer.vue?vue&type=script&lang=ts"
export * from "./PdfViewer.vue?vue&type=script&lang=ts"

import "./PdfViewer.vue?vue&type=style&index=0&id=5cb1f12f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__